import {
  SET_USER_INTERFACE,
  MERGE_USER_INTERFACE,
  ADD_USER_INTERFACE } from '../mutation-type'
import state from 'src/config/ui'

// mutations
const mutations = {
  [SET_USER_INTERFACE] (state, config) {
  },
  [MERGE_USER_INTERFACE] (state, config) {
  },
  [ADD_USER_INTERFACE] (state, config) {
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user-interface.js